export default {
  code: 'Enter Security Code',
  questions: 'Security Questions',
  continue: 'Continue',
  back: 'Back',
};
